// @flow

const RE_YOUTUBE = /.*youtu(?:\.be|be\.com).*(?:\/|\?v=|&v=)([a-zA-Z0-9_-]+)/;

const urlToYouTubeId = (url: string): ?string => {
  const match = url.match(RE_YOUTUBE);
  return match ? match[1] : null;
};

export default urlToYouTubeId;
